import React, { useState, useEffect, useContext } from "react";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Services = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [vendorEmail, setVendorEmail] = useState("");

  useEffect(() => {
    const checkToken = async () => {
      const token = getCurrentToken();
      if (!token) {
        navigate("/login");
      } else {
        setVendorEmail(token.Data.Email);
        await fetchServices();
        setLoading(false);
      }
    };
    checkToken();
  }, [navigate]);

  const fetchServices = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorServicesbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        setServices(response.Data);
      }
    } catch (error) {
      console.error("Failed to fetch services:", error);
    }
  };

  const showFormPopup = async () => {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;

    const { value: formValues } = await MySwal.fire({
      title: "Add New Service",
      html: `
        <select id="ServiceName" class="swal2-input bg-light border-0 mt-3 w-50" style="border: none; border-radius: 8px;">
            <option value="" class="text-muted" disabled selected>Select Service Name</option>
               <option value="AI">AI</option>
                <option value="Horn and Tail Trimming">Horn and Tail Trimming</option>
                <option value="Vaccination">Vaccination</option>
                 <option value="Deworming">Deworming</option>
                 
        </select>
        <textarea id="Description" class="swal2-textarea bg-light border-0" placeholder="Description" style="width: 60%; height: 80px;"></textarea>
        <input id="ServiceRate" class="swal2-input bg-light border-0" placeholder="Service Rate" type="number">
        
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonColor: "#f5821f",
      preConfirm: async () => {
        const ServiceName = document.getElementById("ServiceName").value;
        const Description = document.getElementById("Description").value;
        const ServiceRate = document.getElementById("ServiceRate").value;
        const VendorId = vendorID;
        const ID = 0

        if (!ServiceName || !ServiceRate ) {
          Swal.showValidationMessage("Please fill all required fields.");
          return false;
        }

        const payload = {
          sections: [
            {
              components: [
                { id: 1, value: ServiceName },
                { id: 2, value: Description },
                { id: 3, value: ServiceRate },
               
                { id: 4, value: VendorId },
                { id: 5, value: ID }
              ],
            },
          ],
        };

        try {
          Swal.showLoading();
          const res = await requests.post("RegisterVendorService", payload);
          return res;
        } catch (err) {
          Swal.showValidationMessage("Submission failed!");
          console.error(err);
          return false;
        }
      },
    });

    if (formValues) {
      MySwal.fire({
        icon: "success",
        title: "Success",
        text: formValues?.ResponseMessage || "Service submitted successfully!",
      });
      await fetchServices(); // Fetch the updated list of services
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <div className="container mt-4 px-3" style={{ maxWidth: "1200px" }}>
        <div className="row">
          <div className="card d-flex flex-row align-items-center p-3 border-0" style={{ height: "70px", width: "100%" }}>
            <div className="flex-grow-1">
              <h3 className="mb-0 fw-bold">{vendorEmail} Services</h3>
            </div>
            <button
              onClick={showFormPopup}
              className="btn m-4 text-white"
              style={{ backgroundColor: "#509f0a", borderRadius: "25px" }}
            >
              Add Service <span className="mdi mdi-plus"></span>
            </button>
            <img
              src="../acre-africa-logo.svg"
              alt="User"
              className="rounded-circle"
              style={{ width: "40px", height: "40px", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div
            className="card d-flex flex-row align-items-center p-3 border-0"
            style={{ height: "70px", width: "100%" }}
          >
            <div className="flex-grow-1 mx-2">
              <div className="input-group">
                <input
                  style={{
                    border: "none",
                    backgroundColor: "rgb(243, 243, 243)",
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Search Services... "
                  aria-label="Search"
                />
              </div>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected>
                  Category
                </option>
                <option value="volvo">Food</option>
                <option value="saab">Medicine</option>
                <option value="mercedes">Seeds</option>
                <option value="audi">Machines</option>
              </select>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected>
                  Approval Status
                </option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>

            <div className="flex-grow-1 mx-2">
              <select
                name="sort"
                id="sort"
                className="form-select"
                style={{
                  backgroundColor: "#f8f9fa",
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "rgb(243, 243, 243)",
                }}
              >
                <option value="" disabled selected style={{ color: "#6c757d" }}>
                  Sort By
                </option>
                <option value="volvo">Price</option>
                <option value="saab">Date Created</option>
                <option value="mercedes">Category</option>
                <option value="audi">Type</option>
              </select>
            </div>
          </div>
        </div>

        {/* Display the list of services */}
        <div className="row mt-4">
        {services.length > 0 ? (
          services.map((service) => (
            
            <div className="col-md-3 mb-4" key={service.ID}>
              <div className="card h-100 shadow-sm">
              <img
                  src={`/${service.ID}.jpg`}
                  onError={(e) => (e.target.src = "../2.jpg")} // This line sets a fallback image
                  className="card-img-top"
                  alt={`${service.ProductName} image`} // Alternative text for accessibility
                  height={"200px"}
                />
                <div className="card-body">
              <h5 className="card-title fw-bolder">{service.ServiceName}</h5>
              <p>{service.Description}</p>
              <p>Service Rate: {service.ServiceRate}</p>
              <p>Status: {service.Status ? 'Active' : 'Inactive'}</p>
              {/* Render other service details here */}
              </div>

            </div>
            </div>

          ))
        ) : (
          <p>No services available</p>
        )}
        </div>
      </div>
    </>
  );
};

export default Services;
